import script from "./remote-vnc.vue?vue&type=script&setup=true&lang=ts"
export * from "./remote-vnc.vue?vue&type=script&setup=true&lang=ts"

import "./remote-vnc.vue?vue&type=style&index=0&id=634d18d8&lang=scss"

const __exports__ = script;

export default __exports__